export enum ProcessFlowFindDataWeightType {
  Equal = 1,
  Property,
}